require("core-js/modules/es6.object.prevent-extensions");

require("core-js/modules/es6.object.is-extensible");

var fails = require('../internals/fails');

module.exports = !fails(function () {
  return Object.isExtensible(Object.preventExtensions({}));
});